import { readItems, createItem } from "@directus/sdk";
import directus from "@/lib/directus";

export const parrainageService = {
  fetchParrainageList: async (numero_commercial: string) => {
    try {
      const parrainages = await directus.request(
        readItems("parrainage", {
          filter: {
            numero_commercial: {
              _eq: numero_commercial,
            },
          },
          fields: ["client_id", "date_created", "date_updated", "numero_commercial"],
          sort: ["-date_created"],
        })
      );
      return {
        success: true,
        parrainages,
      };
    } catch (error: any) {
      return {
        success: false,
        error: new Error(error.message || "Erreur lors de la récupération des parrainages"),
      };
    }
  },

  addParrainage: async ({ numero_commercial, client_id }: { numero_commercial: string; client_id: string }) => {
    try {
      // filter deposit to check if users it not already an existing client more than once deposit or more than a week
      const deposit = await directus.request(
        readItems("depot", {
          filter: {
            account_id: {
              _eq: client_id,
            },
          },
          fields: ["account_id", "date_created", "date_updated", "numero_commercial"],
          sort: ["-date_created"],
        })
      );
      if (deposit.length > 0) {
        return {
          success: false,
          error: new Error("ce client est deja parrainé"),
        };
      }
      await directus.request(
        createItem("parrainage", {
          numero_commercial,
          client_id,
        })
      );
      return { success: true };
    } catch (error: any) {
      return {
        success: false,
        error: new Error(error.message || "Erreur lors de l'ajout du parrainage"),
      };
    }
  },
};
